// studentapps/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext({});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('studentAppUser');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const signInWithEmail = async (email) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const user = { 
          email, 
          id: Date.now().toString(),
          name: email.split('@')[0],
          avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(email.split('@')[0])}&background=0a1128&color=fff&bold=true`
        };
        setUser(user);
        localStorage.setItem('studentAppUser', JSON.stringify(user));
        resolve({ success: true, message: 'Welcome back! 🎉' });
      }, 1500);
    });
  };

  const signInWithOTP = async (email) => {
    return signInWithEmail(email);
  };

  const signOut = async () => {
    setUser(null);
    localStorage.removeItem('studentAppUser');
  };

  const value = {
    user,
    signInWithEmail,
    signInWithOTP,
    signOut,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};